module.exports = __webpack_public_path__ + "static/media/sonuma.5f19b1b1.png";